module.exports = __webpack_public_path__ + "static/yogi-zen-e7024d617bd93521c88829fc6ee51f6b.png";